import styled, { css } from 'styled-components';

import { Button } from '../button';
import { Dropdown } from '../dropdown';
import { TextInput } from '../text-input';

import {
  crFont11,
  crFont13,
  crFont9,
  customSlimScroll,
} from '@controlrooms/web/src/app/global-styles';

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.datePickerv2.modalOverlay};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 100px;
  z-index: 1200;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) => theme.datePickerv2.modalContainer.background};
  border-radius: ${({ theme }) => theme.datePickerv2.modalContainer.borderRadius};
  box-shadow: ${({ theme }) => theme.datePickerv2.modalContainer.boxShadow};
  max-width: 820px;
  min-width: 300px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.datePickerv2.modalHeader.borderBottom};
`;

export const MonthYearPickerContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  ${customSlimScroll}
`;

export const Month = styled.div<{ isSelected: boolean }>`
  padding: 4px 6px;
  border: 1px solid transparent;
  background: ${({ theme, isSelected }) =>
    isSelected
      ? theme.datePickerv2.month.selected.background
      : theme.datePickerv2.month.default.background};
  color: ${({ theme }) => theme.datePickerv2.month.default.color};
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
  ${crFont11}
`;

export const Year = styled.div<{ isSelected: boolean }>`
  ${crFont11}
  font-weight: ${({ isSelected }) => (isSelected ? 600 : 400)};
  color: ${({ theme }) => theme.datePickerv2.month.default.color};
`;

export const YearSection = styled.div`
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.datePickerv2.month.separator.borderColor};

  last-child {
    border-bottom: none;
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.datePickerv2.modalTitle.color};
  text-transform: uppercase;
  ${crFont9}
`;

export const ModalCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.datePickerv2.modalCloseButton.color};

  &:hover {
    background-color: ${({ theme }) => theme.datePickerv2.modalCloseButton.hoverBackground};
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  font-family: 'Open Sans';
`;

export const ModalFooter = styled.div`
  padding: 8px;
  border-top: 1px solid ${({ theme }) => theme.datePickerv2.modalFooter.borderTop};
  background-color: ${({ theme }) => theme.datePickerv2.modalFooter.background};
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

// Left panel - Preset list

export const PresetSearch = styled(TextInput)`
  padding: 8px;
  width: 100%;
  border: none;
  box-shadow: none;
  background: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.datePickerv2.presetSearch.borderBottom};
  ${crFont11}
`;

export const LeftPanel = styled.div`
  width: 200px;
  border-left: 1px solid ${({ theme }) => theme.datePickerv2.leftPanel.borderRight};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.datePickerv2.leftPanel.background};
`;

export const PresetListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const PresetItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.datePickerv2.presetItem.default.color};

  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          background-color: ${theme.datePickerv2.presetItem.selected.background};
        `
      : css`
          background-color: ${theme.datePickerv2.presetItem.default.background};

          &:hover {
            background-color: ${theme.datePickerv2.presetItem.selected.background};
          }
        `}
`;

export const PresetLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${crFont11}
`;

export const PresetCheck = styled.div`
  color: ${({ theme }) => theme.datePickerv2.presetCheck.color};
`;

export const PresetDefault = styled.span`
  ${crFont11}
  color: ${({ theme }) => theme.datePickerv2.presetDefault.color};
  background-color: ${({ theme }) => theme.datePickerv2.presetDefault.background};
  padding: 2px 6px;
  border-radius: 10px;
`;

// Right panel
export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const RightPanelHeader = styled.div`
  position: relative;
`;

export const DateRangeDisplay = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.datePickerv2.dateRangeDisplay.color};
  margin-bottom: 20px;
  line-height: 1.4;
`;

export const TabContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  // border-bottom: 1px solid ${({ theme }) => theme.datePickerv2.tabContainer.borderBottom};
`;

export const TabButton = styled.button`
  background: none;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  flex: 1;
  ${crFont13}
  color: ${({ theme }) => theme.datePickerv2.tabButton.default.color};
  border-bottom: 2px solid ${({ theme }) => theme.datePickerv2.tabContainer.borderBottom};
  // transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.datePickerv2.tabButton.hover.color};
  }
`;

export const TzTabButton = styled(Dropdown.Trigger)<{ disabled?: boolean }>`
  background: none;
  border: none;
  padding: 12px 20px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  width: 100px;
  flex-shrink: 0;
  ${crFont13}
  color: ${({ disabled, theme }) =>
    disabled
      ? theme.datePickerv2.tabButton.default.color
      : theme.datePickerv2.tabButton.default.color};
  border-bottom: 2px solid
    ${({ disabled, theme }) =>
      disabled
        ? theme.datePickerv2.tabContainer.borderBottom
        : theme.datePickerv2.tabContainer.borderBottom};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:hover {
    color: ${({ disabled, theme }) =>
      disabled
        ? theme.datePickerv2.tabButton.default.color
        : theme.datePickerv2.tabButton.hover.color};
  }
`;
export const TzList = styled.div`
  max-height: 240px;
  overflow-y: auto;
  ${customSlimScroll}
`;

export const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

// Time input styles
export const TimeInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const TimeInputLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.datePickerv2.timeInputLabel.color};
`;

export const TimeInputField = styled(TextInput)`
  .text-input {
    background: transparent;
    box-shadow: none;
    border: none;
    input {
      ${crFont11}
    }
  }
`;

// Timezone selector styles
export const TimezoneContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TimezoneSearch = styled.div`
  margin-bottom: 16px;
  width: 100%;
`;

export const TimezoneSearchInput = styled(TextInput)`
  width: 100%;
  ${crFont11}
  &:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }
`;

export const TimezoneList = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const TimezoneItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  ${crFont11}
  ${({ isSelected, theme }) =>
    isSelected
      ? css`
          background-color: ${theme.datePickerv2.timezoneItem.selected.background};
          color: ${theme.datePickerv2.timezoneItem.selected.color};
        `
      : css`
          &:hover {
            background-color: ${theme.datePickerv2.timezoneItem.hover.background};
          }
        `}

  &:last-child {
    border-bottom: none;
  }
`;

export const TimezoneLabel = styled.div`
  flex: 1;
  ${crFont11}
`;

export const TimezoneOffset = styled.div`
  ${crFont11}
`;

// Calendar styles
export const CalendarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const QuickRanges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const QuickRangeButton = styled.button`
  padding: 6px 12px;
  border: 1px solid ${({ theme }) => theme.datePickerv2.quickRangeButton.border};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.datePickerv2.quickRangeButton.background};
  cursor: pointer;
  font-size: 12px;
  // transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.datePickerv2.quickRangeButton.hoverBackground};
    border-color: ${({ theme }) => theme.datePickerv2.quickRangeButton.hoverBorder};
  }
`;

export const MonthNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MonthButton = styled(Button)`
  cursor: pointer;
  color: ${({ theme }) => theme.datePickerv2.monthButton.color};
  span {
    ${crFont11}
  }
`;

export const MonthLabel = styled.div`
  ${crFont13}
  font-weight: 600;
  color: ${({ theme }) => theme.datePickerv2.monthLabel.color};
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
`;

export const DayLabel = styled.div`
  padding: 8px;
  width: 20px;
  text-align: center;
  font-weight: 500;
  ${crFont11}
  color: ${({ theme }) => theme.datePickerv2.dayLabel.color};
  border-radius: 4px;
`;

export const DayCell = styled.div<{
  isOtherMonth: boolean;
  isStartDate: boolean;
  isEndDate: boolean;
  isInRange: boolean;
  isInHoverRange: boolean;
  isDisabled: boolean;
}>`
  padding: 8px;
  text-align: center;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  border-radius: 4px;
  ${crFont11}
  font-weight: ${({ isStartDate, isEndDate }) => (isStartDate || isEndDate ? 600 : 400)};
  width: 20px;
  height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isOtherMonth, isStartDate, isEndDate, isInRange, isInHoverRange, isDisabled, theme }) => {
    if (isDisabled) {
      return css`
        background: ${theme.datePickerv2.dayCell.disabled.background};
        color: ${theme.datePickerv2.dayCell.disabled.color};
        cursor: not-allowed;
        border: 1px solid transparent;
      `;
    }

    if (isStartDate || isEndDate) {
      return css`
        color: ${theme.datePickerv2.dayCell.startEnd.color};
        font-weight: 600;
        border-radius: 4px;
        border: 1px solid ${theme.datePickerv2.dayCell.startEnd.border};
        background: ${theme.datePickerv2.dayCell.startEnd.background};
      `;
    }

    if (isInRange) {
      return css`
        color: ${theme.datePickerv2.dayCell.inRange.color};
        border-radius: 4px;
        border: 1px solid ${theme.datePickerv2.dayCell.inRange.border};
        background: ${theme.datePickerv2.dayCell.inRange.background};
      `;
    }

    if (isInHoverRange) {
      return css`
        background: ${theme.datePickerv2.dayCell.hoverRange.background};
        color: ${theme.datePickerv2.dayCell.hoverRange.color};
        border: 1px solid ${theme.datePickerv2.dayCell.startEnd.border};
      `;
    }

    if (isOtherMonth) {
      return css`
        background: ${theme.datePickerv2.dayCell.otherMonth.background};
        color: ${theme.datePickerv2.dayCell.otherMonth.color};
        border: 1px solid transparent;
      `;
    }

    return css`
      background: ${theme.datePickerv2.dayCell.default.background};
      color: ${theme.datePickerv2.dayCell.default.color};
      border: 1px solid transparent;

      &:hover {
        background: ${theme.datePickerv2.dayCell.default.hoverBackground};
      }
    `;
  }}
`;

export const TimePickerLayout = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.datePickerv2.timePickerLayout.borderBottom};
`;

export const TimePickerLeft = styled.div`
  flex: 1;
`;

export const TimePickerRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;
